<template>
  <div>
    <div v-if="isSearchBarVisible">

      <div class="stickySearch" ref="search" :class="{empty: !showSearchResults}">
        <v-container grid-list-md class="vcontainer" :class="{empty: !showSearchResults}">

          <div class="quickBar">

            <div class="c1">
              <div class="prelative">
                <v-text-field
                  :value="searchPhrase" @input="updateSearchPhrase"
                  class="dropdownBorder mb-0"
                  prepend-inner-icon="mdi-magnify"
                  placeholder="Suche"
                  hide-details
                  dense
                  outlined
                  clearable
                  @focus="searchInFocus=true"
                  @blur="searchInFocus=false"
                ></v-text-field>
                <div v-if="!searchInFocus && searchPhrase.length >0" class="absClear dense">
                  <v-icon class="myBlack" @click.passive.stop="searchPhrase=''"
                  >mdi-close
                  </v-icon>
                </div>
              </div>


              <!--        <v-autocomplete-->
              <!--          class="dropdownBorder"-->
              <!--          dense-->
              <!--          v-model="autoModel"-->
              <!--          :items="emptyList"-->
              <!--          :search-input.sync="searchInput"-->
              <!--          item-text="displayName"-->
              <!--          return-object-->
              <!--          hide-details-->
              <!--          outlined-->
              <!--          clearable-->
              <!--          @click:clear="clearSearch"-->
              <!--          ref="itemSearchInput"-->
              <!--          prepend-inner-icon="mdi-magnify"-->
              <!--          no-data-text="Keine Einträge zu diesem Suchbegriff"-->
              <!--          @keyup.native.enter="startSearch($event)"-->
              <!--          persistent-hint-->
              <!--          @blur="blurSearch"-->
              <!--          placeholder="Suche"-->
              <!--        >-->
              <!--        </v-autocomplete>-->
            </div>


            <div class="c2 flexAlignCenter" v-if="!$store.getters.isKiosk">
              <v-btn icon @click.native.passive="$ebus.$emit('goto',{name:'Favoriten'})" class="btnIcon">
                <v-icon small class="myWhite">mdi-heart</v-icon>
              </v-btn>
            </div>

            <div class="c2 flexAlignCenter" v-if="$store.state.showSearchFilter">
              <v-btn icon @click.native.passive="$ebus.$emit('triggerFilterDialog')"
                     class="btnIcon" :class="{'btn-danger': $store.getters.allergenesFilter.length>0}">
                <div class="prelative" v-if="$store.getters.allergenesFilter.length>0">
                  <v-icon small class="myWhite">mdi-filter</v-icon>
                  <v-icon x-small class="myWhite absCheck">mdi-check</v-icon>
                </div>
                <v-icon small class="myWhite" v-else>mdi-filter</v-icon>
              </v-btn>
            </div>

          </div>
        </v-container>


        <div class="absSearchResult" v-show="showSearchResults">
          <v-container grid-list-lg>

            <v-layout row wrap>
              <v-flex xs12 sm6 lg4 v-for="(cat, index) in filteredCategories">
                <CategoryCard class="pointer" @click.native.passive="gotoCategory(cat)"
                              :category="cat"></CategoryCard>
              </v-flex>
            </v-layout>

            <v-layout row wrap class="withBorderLine">
              <v-flex xs12 sm6 lg4 v-for="(item, index) in filteredFoodItems">
                <v-list class="itemsList">
                  <ItemsRow
                    :id="'sfrow'+index"
                    :fordrinks="false"
                    @click.native.passive="expandExtras(item, index)"
                    @close="showItemExtras = false; currentItem={id:''}"
                    :expanded="showItemExtras && currentItem.id === item.id"
                    @expandExtrasForItem="expandExtras(item, index)"
                    :key="item.id"
                    :isSection="!!item.section"
                    :item="item"></ItemsRow>
                  <div class="prelative" style="padding-top: 6px" @click.passive.stop="noOp">
                    <ItemExtrasOverlay
                      v-if="showItemExtras && currentItem.id === item.id"
                      :fordrinks="false"
                      :itemId="currentItem.id"
                      @wasAdded=""
                    ></ItemExtrasOverlay>
                  </div>
                </v-list>
                <!--          <ProductCard class="pointer" @click.native.passive="gotoItem(item)" :item="item"></ProductCard>-->
              </v-flex>

              <v-flex xs12 sm8 lg4 v-for="(item, index) in filteredDrinkItems">
                <v-list class="itemsList">
                  <ItemsRow
                    :id="'sdrow'+index"
                    :fordrinks="true"
                    @click.native.passive="expandExtras(item, index)"
                    @close="showItemExtras = false; currentItem={id:''}"
                    :expanded="showItemExtras && currentItem.id === item.id"
                    @expandExtrasForItem="expandExtras(item, index)"
                    :key="item.id"
                    :isSection="!!item.section"
                    :item="item"></ItemsRow>
                  <div class="prelative" style="padding-top: 6px" @click.passive.stop="noOp">
                    <ItemExtrasOverlay
                      v-if="showItemExtras && currentItem.id === item.id"
                      :fordrinks="true"
                      :itemId="currentItem.id"
                      @wasAdded=""
                    ></ItemExtrasOverlay>
                  </div>
                </v-list>
                <!--          <ProductCard class="pointer" @click.native.passive="gotoItem(item)" :item="item"></ProductCard>-->
              </v-flex>

            </v-layout>
          </v-container>


        </div>

        <!--    <div class="smoother">-->
        <!--      <div class="inner"></div>-->
        <!--    </div>-->
      </div>
    </div>
  </div>

</template>

<script>
import store from '../store/store'
import * as qconst from '../vendor/qconstants';
// import {menuSearch} from "../mixins/menuSearch";
// import {offerMixin} from "../mixins/offerMixin";
import * as util from '@/vendor/util'
import {cloneMe} from '@/vendor/util'
import {getCurrentDevice} from "@/vendor/breakpoints";
import ItemExtrasOverlay from "@/components/ItemExtrasOverlay.vue";
import ItemsRow from "@/components/ItemsRow.vue";
import {getGlobalValue, removeGlobalKey, setGlobalKeyValue} from "@/util/globalState";
import CategoryCard from "@/components/CategoryCard.vue";
// import {gevent} from "../firebase/firebaseUtil";

export default {
  name: "Search",
  components: {CategoryCard, ItemsRow, ItemExtrasOverlay},
  // mixins: [menuSearch,
  //   // offerMixin
  // ],
  data() {
    return {
      currentItem: {},
      showItemExtras: false,
      searchInFocus: false,
      hideResults: false,

      itemsFoods: [],
      itemsDrink: [],
    }
  },
  watch: {},
  created() {
  },
  computed: {
    isSearchBarVisible() {
      let is = this.$store.getters.showSearch && this.$store.getters.appLoaded && this.routeWithSearch;
      this.$store.commit('searchBarVisible', is);
      return is;
    },
    routeWithSearch() {
      let rn = this.$route.name;
      let withSearch =
        rn.indexOf('SpeisenProdukte') !== -1
        || rn.indexOf('GetraenkeProdukte') !== -1
        || rn.indexOf('Sortiment') !== -1
        || rn.indexOf('Speise') !== -1
        || rn.indexOf('Getraenk') !== -1
        || rn.indexOf('Speisen') !== -1
        || rn.indexOf('Getraenke') !== -1
      ;
      store.commit('searchIsRenderedNow', withSearch);
      return withSearch;
    },
    filteredCategories() {
      let fcats = cloneMe(store.getters.foodMenu);
      for (let fcat of fcats) {
        // fcat.pId = 'food' + fcat.id;
        fcat.type = 'food';
      }
      let dcats = cloneMe(store.getters.drinkMenu);
      for (let dcat of dcats) {
        // dcat.pId = 'drink' + dcat.id;
        dcat.type = 'drink';
      }
      let combinedCats = fcats.concat(dcats);

      let phrase = (store.getters.menuSearchPhrase || '').toLowerCase();
      if (phrase && phrase.length > 1) {
        let filteredCats = [];
        for (let cat of combinedCats) {
          if (cat.search) {
            if (cat.search.includes(phrase)) {
              filteredCats.push(cat);
            } else {
              // console.log('filteredBy menuSearchPhrase');
            }
          } else {
            console.log('item.search is missing');
            filteredCats.push(cat);
          }
        }
        return filteredCats;
      } else {
        return [];
      }
    },
    filteredFoodItems() {
      return this.itemsFoods;
    },
    filteredDrinkItems() {
      return this.itemsDrink;
    },
    showSearchResults() {
      let show = store.getters.menuSearchPhrase.length > 0 && !this.hideResults;
      if (show) {
        util.disableScrolling();
      } else {
        util.enableScrolling();
      }
      return show;
    },
    searchPhrase: {
      get() {
        return store.getters.menuSearchPhrase;
      },
      set(value) {
        store.commit('menuSearchPhrase', value);
        if (value.length > 1 || value.length === 0) {
          this.updateFoodItems();
          this.updateDrinkItems();
        }
      }
    },
  },
  mounted() {
    if (getGlobalValue('searchItemClicked')) {
      this.hideResults = true;
    }
  },
  destroyed() {
  },
  methods: {
    async updateFoodItems() {
      this.itemsFoods = await this._filteredFoodItems();
    },
    async updateDrinkItems() {
      this.itemsDrinks = await this._filteredDrinkItems();
    },
    async _filteredFoodItems() {
      let phrase = (store.getters.menuSearchPhrase || '').toLowerCase();
      console.log('filter items by menuSearchPhrase ' + phrase);
      if (phrase && phrase.length > 1) {
        let cats = store.getters.foodMenu;
        cats = util.cloneMe(cats);
        // cats = util.cloneMe(cats.concat(store.getters.allDrinkMenu));

        for (let cat of cats) {
          if (!cat.items) {
            cat.items = [];
            continue;
          }

          let filteredItems = [];
          for (let item of cat.items) {
            if (item.search) {
              if (item.search.includes(phrase)) {
                filteredItems.push(item);
              } else {
                // console.log('filteredBy menuSearchPhrase');
              }
            } else {
              console.log('item.search is missing');
              filteredItems.push(item);
            }
          }
          cat.items = filteredItems;
        }

        let list = [];
        cats.forEach(cat => cat.items.forEach(item => list.push(item)));

        return list;

      } else {
        return [];
      }
    },
    async _filteredDrinkItems() {
      let phrase = (store.getters.menuSearchPhrase || '').toLowerCase();
      console.log('filter items by menuSearchPhrase ' + phrase);
      if (phrase && phrase.length > 1) {
        let cats = store.getters.drinkMenu;
        cats = util.cloneMe(cats);
        // cats = util.cloneMe(cats.concat(store.getters.allDrinkMenu));

        for (let cat of cats) {
          if (!cat.items) {
            cat.items = [];
            continue;
          }

          let filteredItems = [];
          for (let item of cat.items) {
            if (item.search) {
              if (item.search.includes(phrase)) {
                filteredItems.push(item);
              } else {
                // console.log('filteredBy menuSearchPhrase');
              }
            } else {
              console.log('item.search is missing');
              filteredItems.push(item);
            }
          }
          cat.items = filteredItems;
        }

        let list = [];
        cats.forEach(cat => cat.items.forEach(item => list.push(item)));

        return list;

      } else {
        return [];
      }
    },
    gotoCategory(_cat) {
      let forDrinks = _cat.type === 'drink';
      let cat = cloneMe(_cat);
      this.hideResults = true;
      this.searchPhrase = '';
      setTimeout(() => {
        util.jumpToTop();
      }, 160);
      setTimeout(() => {
        if (forDrinks) {
          this.$router.push({name: 'GetraenkeProdukte', params: {catname: cat.categoryDE}});
        } else {
          this.$router.push({name: 'SpeisenProdukte', params: {catname: cat.categoryDE}});
        }
      }, 400);
    },
    updateSearchPhrase(value) {
      this.$nextTick(() => {
        if (value?.length) {
          if (!getGlobalValue('searchItemClicked')) {
            this.hideResults = false;
          }
        }
        this.searchPhrase = value;
      });
    },
    noOp() {
      return false;
    },
    expandExtras(itemToExpand, index) {
      if (itemToExpand.section) {
        return;
      }
      console.log('expandExtras...');
      if (this.showItemExtras && this.currentItem.id === itemToExpand.id) {
        this.showItemExtras = false;
        return;
      }
      if (qconst.useExtrasExpander && getCurrentDevice() === 'xs') {
        this.currentItem = itemToExpand;
        this.showItemExtras = true;
        // setTimeout(() => {
        let ref = 'sf';
        if (itemToExpand.type === qconst.type$drinkOrder) {
          ref = 'sd';
        }
        let div = this.$refs.search;
        let el = document.getElementById(ref + 'row' + index);
        setTimeout(() => {
          div.scrollTo({
            top: util.offset(el).top - 125,
            left: 0,
            behavior: 'smooth'
          });
        }, 400);
      } else {
        setGlobalKeyValue('searchItemClicked', true);
        this.hideResults = true;
        this.searchPhrase = '';
        this.gotoItem(itemToExpand);
        setTimeout(() => {
          removeGlobalKey('searchItemClicked');
        }, 600);
      }
    },
    gotoItem(item) {
      setTimeout(() => {
        if (item.type === qconst.type$drinkOrder) {
          this.$router.push({name: 'Getraenk', params: {itemId: item.id}});
        } else if (item.type === qconst.type$foodOrder) {
          this.$router.push({name: 'Speise', params: {itemId: item.id}});
        }
      }, 400);
    },
    init() {
    },
    // blurSearch() {
    //   if (!this.searchInput || this.searchInput.length === 0) {
    //     this.clearSearch();
    //   }
    // },
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/base.scss';

//.smoother{
//  position: absolute;
//  bottom: -8px;
//  left: 0;
//  width: 100%;
//
//  .inner{
//    border-radius: 25px;
//    margin: auto;
//    width: calc(100% - 40px);
//    height: 12px;
//    background: linear-gradient(180deg, rgb(white, 255) 0%, rgba(white, 0) 100%);
//  }
//}

.absSearchResult {
  position: absolute;
  z-index: 5;
  top: $headHeight + 50px;
  left: 0;
  width: 100%;
  height: calc(100vh - ($headHeight + 50px));
  overflow-y: scroll;
  background-color: $color-secondary;
  padding-bottom: 140px;
}

.absSearchResult ::v-deep .withBorderLine .v-list.itemsList {
  /*<!--border-bottom: 1px solid $accent;-->*/
  @include bgLinear;
  /*background-color: rgba(#dddddd, 0.2);*/
  @include material-shadow(1);
  padding-left: 12px;
  padding-bottom: 0 !important;
  margin: 2px 0 -2px 0;
  overflow-x: hidden;
  border-radius: $box-border-radius;
}

.absSearchResult ::v-deep .withBorderLine .isSection .v-list.itemsList {
  background-color: transparent;
  box-shadow: none;
  border: none;
  /*.xs6:nth-last-child(2){*/
  /*    border-bottom: none;*/
  /*}*/
  /*.xs6:last-child{*/
  /*    border-bottom: none;*/
  /*}*/
}

.absSearchResult ::v-deep .v-list.itemsList {
  background-color: transparent;
  height: 100%;
  padding-top: 5px;
}

.stickySearch {
  position: absolute;
  width: 100%;
  padding-top: $headHeight - 3px;
  //position: sticky;
  //top: $headHeight;
  background-color: $bg1;
  z-index: 6;

  &.empty {
    border-radius: 0 0 25px 25px;
    //box-shadow: 2px 2px 2px 2px rgba(255, 255, 255, 0.91);
  }
}

.vcontainer {
  padding-bottom: 12px;

  &.empty {
    padding-bottom: 6px;
  }
}

div.dropdownBorder {
  border-radius: $box-border-radius;
  font-weight: bold;
}

.btnIcon {
  background-color: $color-primary;
  border-radius: 8px;
  padding: 4px;
}

.quickBar {
  display: flex;
  width: 100%;
}

.c1 {
  flex-grow: 1;
}

.c2 {
  flex-grow: 0;
  flex-shrink: 0;
  padding-left: 5px;
}


</style>
